var _polygon, _path, _polygon2, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawAroundTheWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 682.15663,
    height: 538.25129,
    viewBox: "0 0 682.15663 538.25129",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "188.862 526.385 201.044 525.001 201.509 477.358 183.53 479.399 188.862 526.385",
    fill: "#ffb8b8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484.74188,714.52179l-38.285,4.34447h0l-1.67854-14.79191h0l23.49311-2.66593a14.88686,14.88686,0,0,1,16.47048,13.11336h0Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.582 525.623 75.842 525.623 81.674 478.334 63.58 478.336 63.582 525.623",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.408,717.88029l-38.53073.00177h0l-.00069-14.88684h0l23.64386-.00109A14.88687,14.88687,0,0,1,358.408,717.88029Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.46523,495.02988l7,22.76923,38,82.23077,10,78-23,1-14-72-48-52-42,136-19-2s16-176,38-194C357.46523,495.02988,393.46523,478.02988,410.46523,495.02988Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.49239,
    cy: 191.34841,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M412.96523,499.52988s3-102-39-95-24.5,105.5-24.5,105.5,9,18,31-2S412.96523,499.52988,412.96523,499.52988Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "96.044 266.656 105.927 304.539 120.984 319.597 100.044 312.656 96.044 266.656",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M413.27557,542.66812a10.0558,10.0558,0,0,1-5.277-14.48822L384.6397,501.13657l18.41437-2.39691,19.35886,26.04828a10.11028,10.11028,0,0,1-9.13733,17.88018Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.8352,425.30564l2.63,51.72424,31,40-13,10-42-42s-15-51-4-66c4.125-5.625,8.67188-7.17188,12.74414-6.9082A13.78032,13.78032,0,0,1,384.8352,425.30564Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.49294,398.03006a1.01364,1.01364,0,0,0-.14318-1.61667,14.28326,14.28326,0,0,1,1.37609-25.03744c7.22107-3.4429,17.00605-.76444,22.34415-7.3804a12.40871,12.40871,0,0,0,2.30264-10.07721c-1.15182-6.24875-5.84939-10.88931-11.11026-14.06958a40.429,40.429,0,0,0-61.08911,39.13443c.67905,6.01413,2.53479,12.75778-1.04129,17.64065-3.14734,4.29746-9.08816,5.10327-14.30673,6.17108-11.19313,2.29032-21.99165,7.57389-29.58752,16.10819s-11.64806,20.50824-9.35788,31.70139,11.478,21.03009,22.77061,22.765c9.19165,1.4122,18.68266-2.4913,25.43251-8.88821s11.01639-15.03534,13.70752-23.937c3.19415-10.56543,4.4541-21.95038,10.22083-31.36185,5.64312-9.20972,17.80392-15.81165,27.33493-11.01526a1.022,1.022,0,0,0,1.14669-.13727Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M566.92169,719.12564h-307a1,1,0,0,1,0-2h307a1,1,0,0,1,0,2Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M877.051,378.6543a113.45516,113.45516,0,1,1-7.18311-39.95154c.24738.66626.48859,1.33246.72333,2.00516v.00635q1.57068,4.43545,2.76672,9.03607A114.22515,114.22515,0,0,1,877.051,378.6543Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M750.33472,301.59162a38.323,38.323,0,0,0-33.64392-1.37646c-4.704,2.04721-9.65717,5.71963-11.22644,12.35137,6.34668-3.7456,14.56237,2.17243,16.19549,11.66614l-.38122.10514c-.86261,6.57574,1.063,13.735,4.79107,17.81237a12.528,12.528,0,0,1,6.01337-8.91839c2.73907-1.8006,5.76929-3.10861,7.86-6.20362,2.47852-3.66922,3.10791-9.03167,4.09247-13.92361S746.88812,302.95472,750.33472,301.59162Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M714.80817,357.549c-1.75769,2.63974-4.10553,4.296-6.21222,6.35827a14.301,14.301,0,0,0-4.518,8.4459c-.26654,2.29708.14588,4.63217.08875,6.95474-.057,2.32242-.83124,4.93677-2.41126,5.51422-2.49383.901-4.39752-3.73117-6.961-4.05481-2.037-.25382-3.87079,2.95071-3.2807,5.73007s3.36316,4.01032,4.95587,2.19553c1.44043,2.4176.42511,6.80249-1.7387,7.54483-.22852,1.52292-.45685,3.03952-.679,4.56244-5.46985-3.82639-10.99683-7.71613-15.64807-13.31931a40.42889,40.42889,0,0,1-9.21375-21.77786c-.60284-6.44074.29187-13.80792-2.665-18.7637-2.367-3.966-6.42816-4.84174-10.08319-4.59421-.66626.04434-1.3388.12051-2.00518.203a112.96626,112.96626,0,0,1,8.17932-18.71936,8.01392,8.01392,0,0,0,2.04956-1.27554c3.40124-2.88715,4.91156-8.73148,7.67175-12.77359q.2666-.39024.55206-.76142c2.82386-3.68679,6.60572-5.5841,10.26075-7.3482,8.09057-3.92786,16.41583-7.9065,24.957-7.36081l-2.43036.2348q-4.25464,11.91692-8.51575,23.83393-.64728,1.82739-1.30713,3.66137c-1.61182,4.518-3.27435,9.32794-3.02679,14.38535.146,2.995,1.18658,6.19327,3.16638,7.22122,1.84656.95184,3.86444-.21579,5.64746-1.37067.75519-.48224,1.504-.96457,2.259-1.45318,2.70954-1.745,5.711-3.53446,8.57282-2.36692,2.62072,1.066,4.55609,4.62595,4.92413,8.465A16.9235,16.9235,0,0,1,714.80817,357.549Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M730.92322,411.78889q-11.87028-7.30866-23.7406-14.61731l.13427-.346c-4.92022,1.874-6.963,10.62-6.14984,17.77243s3.57032,13.5462,4.9632,20.51526a54.45375,54.45375,0,0,1-2.053,28.57345,234.0033,234.0033,0,0,0,27.489-37.87884,20.26462,20.26462,0,0,0,2.48652-5.51355,8.77124,8.77124,0,0,0-.58136-6.23844A6.94574,6.94574,0,0,0,730.92322,411.78889Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M699.69128,323.14463a8.75071,8.75071,0,0,0-.401,6.36352,7.0537,7.0537,0,0,0,3.94092,3.65l4.37256,2.16739c1.45465.72107,3.02264,1.44931,4.50549.85605,1.78858-.71552,3.02869-3.5196,2.70795-6.12275-.34149-2.77014-2.08752-4.67556-3.70245-6.29818q-3.38992-3.40614-6.77973-6.81226l-1.27362,1.55994A17.009,17.009,0,0,0,699.69128,323.14463Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M853.6106,352.75812q2.95083.69484,5.90142,1.38959c-.34271,6.64386-3.636,12.79273-8.05249,15.01993-1.84021.92651-3.88983,1.2691-5.41278,3.00149-1.37695,1.5737-2.075,4.023-2.71594,6.36451q-1.68466,6.12986-3.36951,12.25955c-1.20556,4.40381-2.7539,9.29632-5.88861,10.88269-2.69049,1.3642-5.76812-.30466-7.83667-3.103-2.06866-2.79831-3.33142-6.56125-4.55615-10.22891.07617,3.99768-1.783,7.91925-4.4165,9.30884-2.63971,1.38959-5.85065.13324-7.61463-2.96967-1.2691-2.22729-1.79577-5.16534-3.03955-7.42431-1.24371-2.259-3.85168-3.55347-5.20965-1.43409-.89478,1.40879-.78058,3.5662-1.22474,5.35566a5.81555,5.81555,0,0,1-4.86059,4.67666,8.10531,8.10531,0,0,1-5.81891-2.65884,26.35858,26.35858,0,0,1-7.2276-14.57566,17.38775,17.38775,0,0,1,.20313-7.97c.78045-2.46832,2.665-4.37191,4.537-3.90246,1.231-2.60178-1.19922-6.05368-3.38849-5.74909-2.19561.3046-3.91522,2.65879-5.71734,4.46726-1.79578,1.80847-4.30854,3.122-6.11713,1.32617a2.48135,2.48135,0,0,1-2.32416,2.62915q-.0975.006-.195.0043a8.9977,8.9977,0,0,1-3.28064-1.73867c-4.14362-2.58268-9.40418-.86933-12.34845,4.01669,1.84021-7.83042,4.537-16.81571,10.19085-18.656,2.30988-.75509,4.829-.13324,7.01191-1.44046,3.8645-2.316,4.645-11.06662,1.30719-14.67715.42511,3.41385.34271,7.39886-1.45948,9.73407-1.80212,2.3352-5.5841.81216-5.35559-2.63974a2.31257,2.31257,0,0,1-4.30224.91373c-1.19928-1.82746-1.09772-4.8162-.24744-6.99909a16.48674,16.48674,0,0,1,3.6994-5.25409c3.01416-3.22983,6.07269-6.4978,9.56281-8.52844,3.4964-2.03055,7.53216-2.71585,11.03485-.69794,1.84668,1.066,3.47107,2.84281,5.35565,3.78189a3.96875,3.96875,0,0,0,5.46484-1.27978l.00006-.00006q.03186-.05123.06214-.10355c1.40234-2.4621.74237-6.1171,1.26275-9.19464.93274-5.43808,6.37085-7.98267,9.385-4.39114-2.25262-.5774-4.58148,2.0877-4.86065,5.31765-.28553,3.22983,1.34533,6.49149,3.52813,7.46869,3.66773,1.62439,7.25928-2.46216,10.03235-6.24405q4.34025-5.93943,8.69336-11.87246a14.347,14.347,0,0,1,1.55457-1.891,5.0024,5.0024,0,0,1,6.83417-.13955c2.93164,2.39221,4.30859,7.29739,6.71362,10.67315,3.49,4.90509,8.71246,6.09806,13.573,7.0499q5.43484,1.05657,10.8764,2.12573a112.69,112.69,0,0,1,6.31378,13.94123A38.21131,38.21131,0,0,0,853.6106,352.75812Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M865.32452,429.10776a113.76078,113.76078,0,0,1-9.45489,15.81937c-2.28436-.97723-4.74011.76776-6.87854,2.405-2.23364,1.71332-4.91785,3.3822-7.20856,1.82117-2.34143-1.59906-3.09662-6.07264-2.35419-9.61988a25.632,25.632,0,0,1,4.39112-9.03607c1.90368-2.8428,3.94049-5.79349,6.58667-6.89761,2.65246-1.1041,6.06.45685,6.83417,4.22616l1.87829-.0635c-1.0534-1.44675-.50128-4.44187.91382-4.96854,1.63074-.61548,3.0459,1.62439,4.01031,3.60431C864.47424,427.29282,864.912,428.194,865.32452,429.10776Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M793.38782,402.30463c-4.03723.25388-7.23517-4.71615-9.36023-9.60559s-4.064-10.48083-7.70685-12.96957c-2.08148-1.42209-4.45453-1.61716-6.71222-2.30631a8.311,8.311,0,0,1-5.70019-5.01864l-2.561-1.03452a38.46146,38.46146,0,0,0-9.72339,6.93308,21.732,21.732,0,0,0-5.79388,12.6665c-.4892,5.12613,1.31732,10.84207,4.69281,12.7677,2.66717,1.52161,5.77252.56253,8.47412,1.95548,3.37555,1.74029,5.37952,6.79589,6.13812,11.78759s.56635,10.17923,1.10907,15.2276,2.03851,10.30133,5.1341,12.88843c3.87371,3.23743,9.55792.5473,11.29583-5.346.85248-2.89068.82312-6.15259,1.46082-9.15329,1.1228-5.28439,4.15283-9.205,6.556-13.53976S794.98614,407.33533,793.38782,402.30463Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M753.49384,350.37812a10.77266,10.77266,0,0,1,1.05133,1.11609,3.66683,3.66683,0,0,1-.06452,3.7865,3.5227,3.5227,0,0,0,2.52277-1.2822,16.21376,16.21376,0,0,0,1.93426-2.7247,2.96967,2.96967,0,0,0,.57032-2.37677c-.19074-.54431-.64173-.77646-.95789-1.18582a8.05816,8.05816,0,0,1-.88477-2.56986,4.635,4.635,0,0,0-3.359-3.53991l.20233.03869a1.91908,1.91908,0,0,0-.89893,2.04431c.12256.79184.63135,1.44925.58075,2.25687-.07281,1.16132-1.2334,1.70627-1.30511,2.86774A2.2171,2.2171,0,0,0,753.49384,350.37812Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M746.57672,330.64332l.018-.00351a3.24231,3.24231,0,0,0,.34448-.367Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M747.78748,336.0944a3.52068,3.52068,0,0,0,1.096-3.49018c-.29327-1.32046-1.33129-2.20828-2.28875-1.96441a2.33283,2.33283,0,0,1-2.16907.63861c-.59192-.15241-1.24182-.54489-1.75525-.09885a2.65738,2.65738,0,0,0-.59784,1.16739q-.285.87506-.57013,1.74988a1.10427,1.10427,0,0,0-.06738.66311.56171.56171,0,0,0,.43078.3425l3.42041,1.00833A2.9468,2.9468,0,0,0,747.78748,336.0944Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M833.8595,411.35193q-.79047-1.29432-1.58106-2.58859a8.64807,8.64807,0,0,0-2.08343-2.616,1.84606,1.84606,0,0,0-2.60059.22962l-.00006.00006-.02753.03357.06415.49286a11.13059,11.13059,0,0,1,2.777,5.4183c.12012.88181.07837,1.79444.18371,2.68015a3.12568,3.12568,0,0,0,.97645,2.186c.82989.55439,1.80432-.263,2.39495-1.26046a4.3404,4.3404,0,0,0,.67243-2.76267A4.844,4.844,0,0,0,833.8595,411.35193Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M842.12714,412.47483a5.97438,5.97438,0,0,0-.19294-2.40912,5.28822,5.28822,0,0,1,.80475-2.99811,9.74824,9.74824,0,0,0,1.254-2.74914,2.29934,2.29934,0,0,0-.06012-1.34629c-.17444-.39187-.597-.57064-.83935-.26031l.51867.33408a4.72334,4.72334,0,0,0-2.10492.10192,2.605,2.605,0,0,0-1.59527,1.79831,11.12985,11.12985,0,0,1-.4184,1.86585c-.30945.636-.90832.8475-1.28467,1.4057a3.36093,3.36093,0,0,0,.05292,3.19281,3.727,3.727,0,0,0,2.108,1.65774C841.00323,413.29563,841.83734,413.30762,842.12714,412.47483Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M856.85028,416.917a7.24267,7.24267,0,0,0,.91223,1.67438c.7049.71,1.66278.27365,2.51795.10113a4.35339,4.35339,0,0,1,4.14141,1.66113,10.54144,10.54144,0,0,0-6.06274-7.56393,17.81169,17.81169,0,0,0-6.23517-.975l-.36212.09278C852.68457,414.59333,855.582,414.53327,856.85028,416.917Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M794.49225,422.41056l.00525.01172.10534-.20291Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M792.25867,426.73383a19.84048,19.84048,0,0,0-1.25305,2.75266,23.96251,23.96251,0,0,0-.90815,4.71c-.1134.90771-.14843,2.067.42029,2.50934a.80669.80669,0,0,0,1.0553-.14331,4.17345,4.17345,0,0,0,.765-1.13709,26.195,26.195,0,0,0,2.58252-6.12933,10.66622,10.66622,0,0,0-.423-6.87381Q793.37829,424.57816,792.25867,426.73383Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M770.71136,311.55219a2.5428,2.5428,0,0,0,2.74048.53485,9.04962,9.04962,0,0,0,2.57856-1.70321,6.06684,6.06684,0,0,0,1.56317-1.7052,3.4584,3.4584,0,0,0,.31976-2.6345,2.67591,2.67591,0,0,0-2.03961-1.61343q-1.89825-.563-3.79651-1.12579l.91547-.82511c-.9419-.50549-1.98389.43265-2.57258,1.59412a8.5823,8.5823,0,0,0-.78094,2.404A6.17054,6.17054,0,0,0,770.71136,311.55219Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M793.05377,304.05164a2.09059,2.09059,0,0,0,2.84931.23178,3.18493,3.18493,0,0,0,1.26025-2.26986c.08954-.99546-.40265-2.10181-1.10553-2.18781l.16089-.932c-1.35419-.24456-3.02051-.29354-3.74622,1.35093A3.861,3.861,0,0,0,793.05377,304.05164Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#dccf9c"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.07178,
    cy: 178.89419,
    rx: 8.44737,
    ry: 11.32747,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 854.00984,
    cy: 506.28089,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-360.44773 55.95466) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 804.61326,
    cy: 507.19597,
    rx: 7.55666,
    ry: 5.2568,
    transform: "matrix(0.96632, -0.25735, 0.25735, 0.96632, -362.34695, 43.27341)",
    fill: "#e6e6e6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 862.78507,
    cy: 465.18368,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-349.57593 56.82874) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 878.11928,
    cy: 448.05425,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-307.37876 -69.42422) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 881.80751,
    cy: 417.0489,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-303.53578 -69.20601) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 832.01521,
    cy: 476.65267,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-311.2479 -74.87966) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 856.98859,
    cy: 485.69191,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-312.17034 -71.73819) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 826.66624,
    cy: 511.29438,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-315.55093 -75.27458) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.48041,
    cy: 464.79929,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-358.04223 -8.62878) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.08383,
    cy: 465.71436,
    rx: 7.55666,
    ry: 5.2568,
    transform: "translate(-359.94145 -21.31002) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.25564,
    cy: 423.70208,
    rx: 7.55666,
    ry: 5.25681,
    transform: "matrix(0.96632, -0.25735, 0.25735, 0.96632, -347.17043, -7.75469)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 632.58985,
    cy: 406.57265,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-304.14045 -99.94986) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 636.27809,
    cy: 375.5673,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-300.29746 -99.73165) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 586.48578,
    cy: 435.17107,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-308.00958 -105.40529) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.45916,
    cy: 444.21031,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-308.93203 -102.26383) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 581.13681,
    cy: 469.81278,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-312.31261 -105.80022) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 908.58614,
    cy: 274.86374,
    rx: 7.55666,
    ry: 5.25681,
    transform: "translate(-299.05501 62.20536) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 859.18956,
    cy: 275.77882,
    rx: 7.55666,
    ry: 5.2568,
    transform: "translate(-300.95423 49.52411) rotate(-14.91271)",
    fill: "#e6e6e6"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 917.36137,
    cy: 233.76654,
    rx: 7.55666,
    ry: 5.25681,
    transform: "matrix(0.96632, -0.25735, 0.25735, 0.96632, -288.18321, 63.07944)",
    fill: "#e6e6e6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 932.69558,
    cy: 216.63711,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-278.49003 -64.46748) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 936.38382,
    cy: 185.63175,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-274.64704 -64.24926) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 886.59151,
    cy: 245.23553,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-282.35916 -69.92291) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 911.56489,
    cy: 254.27477,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-283.28161 -66.78145) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 881.24254,
    cy: 279.87724,
    rx: 3.3223,
    ry: 4.77581,
    transform: "translate(-286.66219 -70.31783) rotate(-7.0677)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M594.99137,476.90621c-8.08165,0-13.33564-2.00809-15.66108-6.00039-4.58578-7.87213,3.09455-21.68533,22.82726-41.05525l1.65762,1.68843c-18.32967,17.99344-26.29924,31.55092-22.44059,38.176,2.44175,4.19026,9.70845,5.69228,21.01906,4.34123,11.22819-1.34027,26.10821-5.33564,44.22683-11.87444,37.301-13.462,84.099-36.16945,131.77311-63.9399,47.67262-27.76968,90.50989-57.27632,120.62157-83.08336,5.78355-4.95782,11.03254-9.72732,15.601-14.17484a155.3539,155.3539,0,0,0,16.54457-18.43905c6.75409-9.1708,9.0337-16.23339,6.59233-20.42441-4.07779-6.99981-21.20777-6.34161-48.23722,1.856l-.68631-2.26459c28.99941-8.79376,46.14788-9.05757,50.96821-.7822,2.99518,5.14153.73021,12.88618-6.73137,23.01867a157.68877,157.68877,0,0,1-16.79953,18.731c-4.60389,4.48258-9.89023,9.28558-15.71192,14.27614-30.21682,25.89755-73.1781,55.492-120.97049,83.331-47.79356,27.84054-94.72942,50.61273-132.16056,64.12168-18.28731,6.59965-33.34334,10.63662-44.74984,11.99768A65.2269,65.2269,0,0,1,594.99137,476.90621Z",
    transform: "translate(-258.92169 -180.87436)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAroundTheWorld);
export default __webpack_public_path__ + "static/media/undraw_around_the_world.ba1b23379b23bb1db1832083ebfbbf2f.svg";
export { ForwardRef as ReactComponent };